import Welcome from "./welcome/Welcome";
import FreeVsPro from "./free-vs-pro/FreeVsPro";
import Settings from "./settings/Settings";
import StarterTemplates from "./starter-templates/StarterTemplates";
import CustomLayouts from "./custom-layouts/CustomLayouts";
import SpectraScreen from "./spectra/SpectraScreen";
import ExtensionScreen from "./woocommerce/ExtensionScreen";
import Docs from "./docs/Docs";

export {
	Welcome,
	FreeVsPro,
	Settings,
	StarterTemplates,
	CustomLayouts,
	SpectraScreen,
	ExtensionScreen,
	Docs,
};
